import React from "react";

export function Header() {
    return (
        <div className={'text-neutral-900'}>
            <p className={'font-bold'}>Are you sure you want to Change?</p>
            <p className={'text-sm font-medium'}>Customer will be notified</p>
        </div>
    )
}